import type { Permission } from "../shared/permissions";

/** Get users by organisation id */
export type UsersByOrganisationId = {
  users: User[];
};

export type ResponsibleUsers = {
  users: User[];
};

export type User = {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
};

/** Create User Payload */
export type CreateUserPayload = { email: string; firstname: string; lastname: string };

export type CreatedUser = {
  id: string;
  email: string;
};

export const CreateUserErrorCodes = {
  alreadyExists: "USER_ALREADY_EXIST",
} as const;

export const DeleteUserErrorCodes = {
  hasConnections: "USER_HAS_CONNECTIONS",
} as const;

/** Get users role assignments */
export type UsersRoleAssignmentsOnTenant = {
  tenantId: string;
  tenantName: string;
  users: {
    userId: string;
    email: string;
    firstName: string;
    lastName: string;
    roles: UserRole[];
    editableRoles: Role[];
  }[];
};

/** Get user roles hierarchy */

export type UserRolesHierarchy = {
  user: { userId: string; email: string; firstName: string; lastName: string };
  tenantRolesHierarchy: TenantRolesHierarchy;
  editableRoles: Role[];
};

export const ROLES = [
  "PRIVACY_ONE_CREATOR",
  "PRIVACY_ONE_READ_ONLY",
  "PRIVACY_ONE_INVITOR",
  "PRIVACY_ONE_REVIEWER",
  "SYSTEM_OWNER",
  "PRODUCT_ADMIN",
  "INTERNAL_DRAFTIT_USER",
] as const;

export type Role = (typeof ROLES)[number];

export type UserRole = {
  role: Role;
  inherited: boolean;
};

export type TenantRolesHierarchy = {
  id: string;
  organizationName: string;
  parentId: string | null;
  roles: UserRole[];
  children: TenantRolesHierarchy[];
};

export type TenantHierarchy = {
  id: string;
  organizationName: string;
  parentId: string | null;
  children: TenantHierarchy[];
  permissions: readonly Permission[];
};

/** Update role   */
export type UpdateRolePayload = { tenantId: string; role: Role; action: "revoke" | "grant"; force?: boolean };

export type UpdateRoleResponse<Result extends UserRolesHierarchy | UsersRoleAssignmentsOnTenant> =
  | { fulfilled: true; result: Result }
  | { fulfilled: false; reason: "NO_RESPONSIBLE_PERMISSION_ON_OTHER_ROLE" | "LOSE_PERMISSION_TO_UPDATE_ROLES" };
